import React from 'react';
import { HeroSection } from './components/HeroSection';
import { RealityCheckSection } from './components/RealityCheckSection';
import { WhySection } from './components/WhySection';
import { PromiseSection } from './components/PromiseSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStackSection } from './components/ValueStackSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#FFF8F0] font-['Inter']" data-id="element-0">
      <HeroSection data-id="element-1" />
      <RealityCheckSection data-id="element-2" />
      <WhySection data-id="element-3" />
      <PromiseSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <ForWhoSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <ValueStackSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <CTASection variant="primary" data-id="element-11" />
      <FAQSection data-id="element-12" />
      <CTASection variant="final" data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}